'use client';
import React, { useEffect, useState, useRef } from 'react';
import Cookies from 'js-cookie';
import { X, MailIcon } from 'lucide-react';
import BASE_URL from './constants';
import { motion, AnimatePresence } from 'framer-motion';
import toast from 'react-hot-toast';
import { usePathname } from 'next/navigation';
const EmailSubscribePopUp = () => {
    const [show, setShow] = useState(false);
    const [email, setEmail] = useState("");
    const modalRef = useRef(null);
    const pathname = usePathname();
    useEffect(() => {
        const timer = setTimeout(() => {
            const isDismissed = Cookies.get('dismissedEmailPopup');
            const isSubscribed = localStorage.getItem('subscribed');
            if (!isDismissed && !isSubscribed) {
                setShow(true);
            }
        }, 2000); // 2000ms = 2 seconds

        return () => clearTimeout(timer); // cleanup on unmount
    }, []);


    const handleClose = () => {
        Cookies.set('dismissedEmailPopup', 'true', { expires: 7 });
        setShow(false);
    };

    const [discount, setDiscount] = useState(0);
    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            handleClose();
        }
    };
    useEffect(() => {
        if (!show) return;
        const url = `${BASE_URL}/v1/discount/get-app-discount`;

        fetch(url)
            .then(res => res.json())
            .then(data => {
                const discountPer = data?.response?.discount_per
                if (discountPer) {
                    setDiscount(discountPer);
                }
            })
            .catch(err => {
                console.error("Failed to fetch discount:", err);
            });
    }, [show]);

    if (!show) return null;
    if (!discount) return null;
    if (pathname.startsWith('/checkout')) return null;
    const handleSubmit = async (e) => {
        e.preventDefault();
        const apiUrl = `${BASE_URL}/v1/subscription/subscribe`;
        const postData = {
            email,
        }; // Replace this with your actual data

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData), // Convert your data to JSON format
        };

        try {
            const res = await fetch(apiUrl, requestOptions);
            if (res.ok) {
                localStorage.setItem('subscribed', true);
                toast.success('Subcribed Successfully');
                setEmail('');
            }
            if (res.status == '400') {
                localStorage.setItem('subscribed', true);
                toast.error('Already Subscribed');
            }
            // Handle the response here
        } catch (error) {
            // Handle any errors
            console.error('Error:', error);
        } finally {
            handleClose(); // Close the popup after submission
        }
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="fixed inset-0 z-50 p-5 flex justify-center md:justify-end items-center md:items-end bg-black/50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={handleOutsideClick} // attach outside click listener
                >
                    <motion.div
                        ref={modalRef} // reference for modal
                        className="relative w-[360px] md:w-[450px] max-w-[95%] bg-white rounded-xl shadow-xl  p-5"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        onClick={(e) => e.stopPropagation()} // prevent inner click from closing
                    >
                        {/* Your modal content here (no change needed) */}

                        <button
                            onClick={handleClose}
                            className="absolute -top-5 -right-5 text-white z-10 shadow-sm p-0.5"
                        >
                            <X className="w-5 h-5" />
                        </button>
                        <div
                            className="w-full overflow-hidden rounded-md p-4 md:p-5 text-center shadow-md border-2 border-dashed border-gray-300"
                            style={{
                                backgroundImage: "url('https://res.cloudinary.com/genx21/image/upload/fl_preserve_transparency/v1752139324/ztiknrhrgi6oetnw7w9q.jpg?_s=public-apps')",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundPositionX: "center",
                                backgroundPositionY: "center",
                            }}
                        >
                            <div className="mb-4">
                                <img
                                    src="https://res.cloudinary.com/genx21/image/upload/v1733467899/images/ymrlt4hltxftbonhpsd3.png"
                                    alt="Logo"
                                    className="h-8 mx-auto mb-2"
                                />
                                <p className="text-xs md:text-sm font-medium text-gray-700">Stay Ahead with</p>
                                <h2 className="text-xl md:text-2xl font-bold text-black mt-1">Exclusive Drops</h2>
                            </div>

                            <form onSubmit={(e) => handleSubmit(e)} className="space-y-2">
                                <input
                                    type="email"
                                    placeholder="Enter your email address"
                                    value={email}
                                    required
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black text-sm placeholder-gray-500"
                                />
                                <button className="w-full text-sm md:text-base bg-black text-white py-2 rounded-md font-medium hover:bg-gray-900 flex items-center justify-center gap-1">
                                    <MailIcon className="w-4 h-4" />
                                    Get on the List
                                </button>
                            </form>

                            <p className="text-xs text-gray-600 font-semibold mt-4">10% OFF First Order + Early Access</p>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>

    );
};

export default EmailSubscribePopUp;
